<template>
  <div style="width:110%;height:104%;position:relative">
    <div class="titlegaga">设备分布图</div>
    <div id="china-map"></div>
    <div class="data">
      <div>在线设备数：{{ onlineDeviceNum }}</div>
      <div class="m_t_10">离线设备数：{{ deviceNum - onlineDeviceNum }}</div>
      <div class="m_t_10">当日订单数：
        <CountTo
                    :startVal="beginOrder"
                    :endVal="endOrder"
                    :duration="4000"
                  ></CountTo></div>
    </div>
  </div>
</template>

<script>
import geoJson from './index.js';
import * as echarts from 'echarts';
import CountTo from '../CountTo/vue-countTo.vue';
echarts.registerMap('china', geoJson);
export default {
  props:['data','onlineDeviceNum','deviceNum','orderNum','beginOrder','endOrder'],
  components:{CountTo},
  methods: {
    init() {
      // 基于准备好的dom，初始化echarts实例
      var chinaMap = echarts.init(document.getElementById('china-map'));
      window.onresize = chinaMap.resize; // 窗口或框架被调整大小时执行chinaMap.resize
      chinaMap.setOption({
        grid:{
          left: '20px',
          right: '20px',
          bottom: '20px',
          height: '20px'
        },
        layoutSize:'100%',
        tooltip: {
          // 鼠标移到图里面的浮动提示框
          backgroundColor: 'rgba(0,0,0,0.5)', //提示框背景色
          borderColor: 'rgba(0,0,0,0)', //边框夜色
          textStyle: {
            color: 'rgba(255, 255, 255, 1)', //文字颜色
          },
          //自定义提示框自动调用函数
          formatter: function (params) {
            if (!params.data) {
              return null;
            }
            let showname = params.data;
            return `
                <div style='width:100%;height:60px'>
                    <div style="font-size:12px" >校区：${
                      showname.name ? showname.name : '无名'
                    }</div>
                    <div style="font-size:12px" >设备数量：${
                      showname.equipmentCount||0
                    }</div>
                    <div style="font-size:12px">用户数量：${
                      showname.registerCount||0
                    }</div> 
              </div>
              `;
          },
        },
        dataRange: {
          show: false,
          min: 0,
          max: 1000,
          text: ['High', 'Low'],
          realtime: true,
          calculable: true,
          color: ['#fd7b78'],
        },
        geo: {
          // 这个是重点配置区
          map: 'china', // 表示中国地图
          // roam: true, //是否允许放大
          label: {
            normal: {
              show: false, // 是否显示对应地名
              textStyle: {
                color: '#fc5f29', //对应地名颜色
              },
            },
          },
          aspectScale: 0.80,
          layoutCenter: ["46%", "46%"],
          layoutSize: '120%',
          //点击变色
          select: {
            itemStyle: {
              areaColor: '#fc5f29', //点击之后的省份颜色
              zoom:1.4
            },
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(147, 235, 248, 1)',
              borderWidth: 1,
              areaColor: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(147, 235, 248, 0)', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(147, 235, 248, .2)', // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              shadowColor: 'rgba(128, 217, 248, 1)',
              // shadowColor: 'rgba(255, 255, 255, 1)',
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10,
            },
            emphasis: {
              areaColor: '#389BB7',
              borderWidth: 0,
            },
          },
          regions: [
            {
              name: '南海诸岛',
              value: 0,
              show: false,
              itemStyle: {
                normal: {
                  opacity: 0,
                  label: {
                    show: false,
                  },
                  color: '#71D4E7',
                },
              },
            },
          ],
        },
        series: [
          {
            type: 'scatter',
            coordinateSystem: 'geo', // 对应上方配置
          },
          {
            // name: "启动次数", // 浮动框的标题
            type: 'map',
            mapType: 'china',
            geoIndex: 0,
            data: this.provinceInfo,
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            showEffectOn:'render',
            effectType: "ripple",
            rippleEffect: {
              //动画的时间
              period: 4,
              //动画中波纹的最大缩放比例
              scale: 4,
              //波纹的绘制方式可选 'stroke' 和 'fill'
              brushType: "stroke"
            },
            data: this.data.map(function (item) {
              return {
                name: item.name,
                equipmentCount: item.equipmentCount,
                registerCount: item.registerCount,
                symbolSize:item.registerCount>10000&&item.registerCount<100000?8:(item.registerCount>=100000&&item.registerCount<1000000?14:(item.registerCount>1000000?26:4)),
                value: [item.longitude, item.latitude, 10], // 最后一个数字控制涟漪特效的大小
              };
            }),
            symbolSize: 10, // 控制散点的大小
            label: {
              show: false, // 不显示标点上的标签，避免重叠
            },
            emphasis: {
              itemStyle: {
                color: '#FF5733', // 鼠标悬停时的标点颜色
              },
            },
          },
        ],
      });
      // 地图打点-----
      var cityData = [
        {
          name: '北京',
          oredrNum: 599, //订单数量
          goodsNum: 599, //货品数量
        },
        {
          name: '天津',
          ename: '天津',
        },
        {
          name: '上海',
          oredrNum: 142,
          goodsNum: 599,
        },
        {
          name: '重庆',
          ename: '重庆',
        },
        {
          name: '河北',
          ename: '河北',
        },
        {
          name: '河南',
          ename: '河南',
        },
        {
          name: '云南',
          ename: '云南',
        },
        {
          name: '辽宁',
          ename: '辽宁',
        },
        {
          name: '黑龙江',
          oredrNum: 44,
          goodsNum: 599,
        },
        {
          name: '湖南',
          ename: '湖南',
        },
        {
          name: '安徽',
          ename: '安徽',
        },
        {
          name: '山东',
          ename: '山东',
        },
        {
          name: '新疆',
          oredrNum: 1, //订单数量
          goodsNum: 599, //货品数量
          ename: '新疆',
        },
        {
          name: '江苏',
          ename: '江苏',
        },
        {
          name: '浙江',
          value: 3,
          ename: '浙江',
        },
        {
          name: '江西',
          ename: '江西',
        },
        {
          name: '湖北',
          oredrNum: 810,
          goodsNum: 599,
        },
        {
          name: '广西',
          ename: '广西',
        },
        {
          name: '甘肃',
          ename: '甘肃',
        },
        {
          name: '山西',
          ename: '山西',
        },
        {
          name: '内蒙古',
          ename: '内蒙古',
        },
        {
          name: '陕西',
          ename: '陕西',
        },
        {
          name: '吉林',
          ename: '吉林',
        },
        {
          name: '福建',
          oredrNum: 106,
          goodsNum: 30211111,
        },
        {
          name: '贵州',
          ename: '贵州',
        },
        {
          name: '广东',
          value: 53,
          ename: '广东',
        },
        {
          name: '青海',
          ename: '青海',
        },
        {
          name: '西藏',
          ename: '西藏',
        },
        {
          name: '四川',
          oredrNum: 453,
          goodsNum: 599,
        },
        {
          name: '宁夏',
          ename: '宁夏',
        },
        {
          name: '海南',
          ename: '海南',
        },
        {
          name: '台湾',
          ename: '台湾',
        },
        {
          name: '香港',
          ename: '香港',
        },
        {
          name: '澳门',
          ename: '澳门',
        },
      ];
      const geoCoordMap = {
        广东: [113.75, 23.04],
        黑龙江: [128.34, 47.05],
        北京: [116.4, 40.4],
        新疆: [86.61, 40.79],
        内蒙古: [112.17, 42.81],
        青海: [97.07, 35.62],
        西藏: [89.13, 30.66],
      };
      this.convertData = data => {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value), //将上面数组的value添加到经纬度后面
              oredrNum: data[i].oredrNum ? data[i].oredrNum : '暂无数据',
              goodsNum: data[i].goodsNum ? data[i].goodsNum : '暂无数据',
            });
          }
        }
        return res;
      };
      // this.getMapChart(points);
    },
    getMapChart(data) {
      var myChart = this.$echarts.init(document.getElementById('china-map'));
      var option = {
        tooltip: {
          show: true,
          textStyle: {
            color: '#fff',
          },
        },
        series: [
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: this.data.map(function (item) {
              return {
                name: item.name,
                value: [item.local[0], item.local[1], 1], // 最后一个数字控制涟漪特效的大小
              };
            }),
            symbolSize: 10, // 控制散点的大小
            label: {
              show: false, // 不显示标点上的标签，避免重叠
            },
            emphasis: {
              itemStyle: {
                color: '#FF5733', // 鼠标悬停时的标点颜色
              },
            },
          },
        ],
      };
      myChart.on('click', params => {});
      myChart.setOption(option);
      window.onresize = () => {
        myChart.resize();
      };
    },
  },
};
</script>

<style lang="css">
#china-map {
  height: 100%;
}
.color_f21{
  color: #fc5f29;
  font-family: 'a';
  font-size: 1.4vw;
}
.titlegaga {
  font-family: 'a';
  font-size: 1.4vw;
  color: #0DD4DB;
  height: 2vw;
}
.m_t_10{
  margin-top: 10px;
}
.data{
  position: absolute;
  left: 0px;
  bottom: 4vh;
  font-size: 1vw;
  color: #0DD4DB;
  /* border: solid 2px #eee; */
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /* box-shadow: 2px 4px 4px 4px  #888888; */
}
</style>